class Gui {
  constructor(type) {
    if (!['evento', 'ficha'].includes(type)) {
      throw new Error('O type deve ser evento ou ficha')
    }
    this.type = type
  }

  get isEvento() {
    return this.type === 'evento'
  }

  get isFicha() {
    return this.type === 'ficha'
  }

  get event() {
    return this.isEvento ? 'Evento' : 'Ficha'
  }

  // Lotes e Produtos
  // ----------------

  get batches() {
    return this.isEvento ? 'Lotes' : 'Produtos'
  }

  get batch() {
    return this.isEvento ? 'Lote' : 'Produto'
  }

  get batchLC() {
    return this.isEvento ? 'lote' : 'produto'
  }

  get batchesLC() {
    return this.isEvento ? 'lotes' : 'produtos'
  }

  get batchesExample() {
    return this.isEvento ?
      'Exemplos: Masculino, Feminino, Cortesia' :
      'Exemplos: Água, Refrigerante, Cerveja'
  }

  // Revendedores e Pontos de Vendas
  // -------------------------------

  get dealer() {
    return this.isEvento ? 'Revendedor' : 'Ponto de Venda'
  }

  get dealers() {
    return this.isEvento ? 'Revendedores' : 'Pontos de Vendas'
  }

  get dealersLC() {
    return this.isEvento ? 'revendedores' : 'pontos de vendas'
  }

  get dealerLC() {
    return this.isEvento ? 'revendedor' : 'ponto de venda'
  }

  get tickets() {
    return this.isEvento ? 'Ingressos' : 'Fichas'
  }

  get ticketLC() {
    return this.isEvento ? 'ingresso' : 'ficha'
  }

  get ticketOfLC() {
    return this.isEvento ? 'do ingresso' : 'da ficha'
  }

  get emptyTicket() {
    return this.isEvento
      ? 'Nenhum ingresso encontrado'
      : 'Nenhuma ficha encontrada'
  }

  get printReport() {
    return this.isEvento ? 'Vendas' : 'Vendas'
  }

  get createdBatches() {
    return this.isEvento ? 'Lotes cadastrados' : 'Produtos cadastrados'
  }
}

export default Gui;
